module.exports = __webpack_public_path__ + "static/Exhibition-f452e60285c5d17d7748caad4265ae4a.svg";